'use strict';
class EPiServerFormsElement {
    constructor(elements) {
        if (elements !== null) {
            [].forEach.call(elements, element => this.elementInit(element));
        }
    }
    elementInit(element) {
        element.addEventListener('focus', evt => this.elementFocus(evt));
        element.addEventListener('blur', evt => this.elementBlur(evt));
        element.addEventListener('keyup', evt => this.elementChange(evt));
        element.addEventListener('change', evt => this.elementChange(evt));
        if (!element.value) {
            element.classList.add('empty-element');
        }
    }
    elementFocus(evt) {
        evt.target.classList.add('focus-element');
    }
    elementBlur(evt) {
        evt.target.classList.remove('focus-element');
    }
    elementChange(evt) {
        if (evt.target.value) {
            evt.target.classList.remove('empty-element');
        }
    }
}
class EPiServerFormsInput extends EPiServerFormsElement {
    constructor(inputs) {
        if (inputs !== null) {
            super(inputs);
        }
    }
}
class EPiServerFormsSelect extends EPiServerFormsElement {
    constructor(selects) {        
        if (selects !== null) {
            super(selects);
        }
    }
}
class EPiServerFormsTextarea extends EPiServerFormsElement {
    constructor(textareas) {
        if (textareas !== null) {
            super(textareas);
            [].forEach.call(textareas, textarea => this.initTextarea(textarea));
        }
    }
    initTextarea(textarea) {
        textarea.addEventListener('keyup', evt => this.textareaChange(evt));
    }
    textareaChange(evt) {
        evt.target.style.height = (evt.target.scrollHeight) + "px";
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new EPiServerFormsInput(document.querySelectorAll('.EPiServerForms input'));
    new EPiServerFormsSelect(document.querySelectorAll('.EPiServerForms select'));
    new EPiServerFormsTextarea(document.querySelectorAll('.EPiServerForms textarea'));
});


// WEBPACK FOOTER //
// ./Components/Shared/forms.js